document.addEventListener('acpa_field_updated', e => {
        const elem = document.querySelector('.aco_custom_class');
        if(elem) {
          const btn = document.querySelector('.show-more-options');
          if (btn) {
            btn.style.display = 'none';
          }

        }
})